<template>
    <div class="legal-page">
        <DemoBanner @change="testEnvironment = $event" />
        <main class="legal-placeholder" data-testid="legal-placeholder">
            <h1>{{ $t(`authFooter.${titleKey}`) }}</h1>
            <p>{{ $t('authFooter.6') }}</p>
            <a :href="backPath">{{ $t('authFooter.7') }}</a>
            <AuthFooter :test-environment="testEnvironment" />
        </main>
    </div>
</template>
<script>
import DemoBanner from '@/components/service/DemoBanner';
import AuthFooter from '@/components/service/AuthFooter';
export default {
    components: { DemoBanner, AuthFooter },
    data() { return { testEnvironment: false }; },
    computed: {
        backPath() { return process.env.VUE_APP_TOR === 'true' ? '/auth/' : '/'; },
        titleKey() {
            return { terms: 3, privacy: 4, datenschutz: 5 }[this.$route.params.document];
        },
    },
};
</script>
<style scoped>
.legal-page { width: 100%; min-height: 100vh; background: #fff; color: #242424; }
.legal-placeholder { max-width: 720px; margin: 0 auto; padding: 48px 24px; overflow-wrap: anywhere; }
h1 { font-size: 28px; line-height: 1.3; margin-bottom: 24px; }
p { margin-bottom: 24px; }
a { color: #334dad; text-decoration: underline !important; }
a:focus-visible { outline: 2px solid currentColor; outline-offset: 4px; }
</style>
